import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	membersPlain: {
		id: 'ptc-directory.user-profile-page.about.teams.item.members.plain',
		defaultMessage: '{memberCount, number} {memberCount, plural, one {member} other {members}}',
		description:
			'Either the number of members your team has when you are viewing your own profile, or someone elses team that you are not a member of',
	},
	membersIncludingYou: {
		id: 'ptc-directory.user-profile-page.about.teams.item.members.including.you',
		defaultMessage:
			'{memberCount, number} {memberCount, plural, one {member, including you} other {members, including you}}',
		description:
			'The number of team members, when viewing someone elses profile and you are also a member',
	},
	createTeamLabel: {
		id: 'ptc-directory.team-profile-page.create.team.button',
		defaultMessage: 'Create a team',
		description:
			'Label of the CTA to create a new team. It is located in the list of teams a user is already a member of',
	},
	createTeamLabelOtherPeople: {
		id: 'ptc-directory.team-profile-page.create.team.button.other-people',
		defaultMessage: 'Create a team together',
		description:
			'Label of the CTA to create a new team with other people. It is located in the list of teams a user is already a member of',
	},
});
